module.exports = __webpack_public_path__ + "assets/img/b13f13282a66007ca3016d3db10684ab.webp";